import React, { useState, useEffect } from 'react';
import 'rc-pagination/assets/index.css';
import { Form, Button, Col, Row, Table } from "react-bootstrap";
import 'bootstrap-daterangepicker/daterangepicker.css';
import Select from 'react-select';
import { currencyFormat } from '../../../src/utils/functions'
import imagePlaceholder from '../../assets/img/imagePlaceholder.jpg';

/**
 * 
 * @param {
 *          products, 
 *          product:{
 *              productId, 
 *              price, 
 *              quantity
 *              bodyPart, 
 *          },
 *          index,
 *          changeOrderRow, 
 *          removeProduct, 
 *          addProduct, 
 *          key,
 *          currency:{
 *              code, 
 *              symbol
 *          } 
 *        } props 
 * @returns 
 */
const ProductRow = (props) => {


    const bodyParts = [
        {
            value: 1,
            label: "Left Arm",
        },
        {
            value: 2,
            label: "Right Arm",
        },
        {
            value: 3,
            label: "Chest",
        },
        {
            value: 4,
            label: "Neck",
        },
        {
            value: 5,
            label: "Back",
        },
        {
            value: 6,
            label: "Left Leg",
        },
        {
            value: 7,
            label: "Right Leg",
        },
        {
            value: 9,
            label: "Wrist"
        }
    ]

    const color = [
        {
            value: 1,
            label: "Black & White",
        },
        {
            value: 2,
            label: "Colored",
        },
        {
            value: 3,
            label: "Mixed",
        },
    ]
    const [size, setSize] = useState([])
    const [lightbox, setLightBox] = useState(false)
    const [lightboxImage, setLightBoxImage] = useState("")
    useEffect(() => {
        let tempSizeOption = []
        for (var key in props.sizeGroup) {
            tempSizeOption.push({
                label: props.sizeGroup[key].width + `*` + props.sizeGroup[key].height,
                value: props.sizeGroup[key].width + `*` + props.sizeGroup[key].height,
                blackAndWhitePrice: props.sizeGroup[key].blackAndWhitePrice,
                coloredPrice: props.sizeGroup[key].coloredPrice,
                mixedPrice: props.sizeGroup[key].mixedPrice,
                key: key
            })
        }
        setSize(tempSizeOption) // Set Group Size
    }, [])
    const products = props.products
    const [product, setProduct] = useState(props.product_)
    useEffect(() => {
        props.changeOrderRow(props.index, product)
    }, [product])


    return (
        <>
            {
                <>
                    {lightbox &&
                        <div style={{
                            position: "fixed",
                            top: "0px",
                            right: "0px",
                            width: "100%",
                            zIndex: "9999",
                            height: "100vh",
                            textAlign: "center",
                            background: "#00000047"
                        }}>
                            <p onClick={() => setLightBox(false)}
                                style={{
                                    color: "#fff",
                                    fontSize: "30px",
                                    position: "fixed",
                                    top: "40px",
                                    right: "40px",
                                    background: "#F8940E",
                                    height: "45px",
                                    width: "45px",
                                    cursor:"pointer"
                                }}>X</p>
                            <img src={lightboxImage} style={{
                                width: "35%",
                                margin: "auto",
                                paddingTop: "4%"
                            }} />
                            <a className="btn btn-success" style={{
                                position: "fixed",
                                top: "40px",
                                right: "100px",
                                height: "45px",
                                fontSize: "25px",
                                margin: "auto",
                                lineHeight: "30px"
                            }} target="_black" href={lightboxImage}>Download</a>
                        </div>
                    }
                    <tr>
                        <td>
                            {products.map((item, index) => {
                                if (item.value === props.product_?.productId) {
                                    return item.label
                                }
                            })
                            }
                            <br />

                            Prompt: {props?.product_?.designs[0]?.prompt}

                        </td>
                        <td>
                            <Col md="12">
                                <Form.Group>
                                    <div id="productsDiv">
                                        <Row>
                                            <Table bordered size="sm">
                                                <thead>
                                                    <tr>

                                                        <th style={{ "width": "5%" }}>Design</th>
                                                        <th style={{ "width": "3%" }}>Quantity</th>
                                                        <th style={{ "width": "25%" }}>Size</th>
                                                        <th style={{ "width": "10%" }}>Unit Price</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {props.product_.designs.map((design, index) => {
                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <img style={{ height: "50px", width: "50px" }} src={design.image ? design.image : imagePlaceholder} onClick={() => {
                                                                        setLightBox(true)
                                                                        setLightBoxImage(design.image ? design.image : imagePlaceholder)
                                                                    }} />
                                                                </td>
                                                                <td>
                                                                    {props.product_?.productId ? "-" :
                                                                        <Form.Control
                                                                            readOnly={props.product_?.productId ? true : false}
                                                                            style={{ "height": "37px" }}
                                                                            onChange={(event) => {
                                                                                if (event.target.value > 0) {
                                                                                    let temp = { ...product }
                                                                                    temp.designs[index].quantity = event.target.value
                                                                                    setProduct(temp)
                                                                                } else {
                                                                                    setProduct({ ...product.designs[index], quantity: 1 })
                                                                                }

                                                                            }}
                                                                            value={design.quantity}
                                                                            type="Number"
                                                                            min={1}
                                                                        ></Form.Control>
                                                                    }

                                                                </td>
                                                                <td>
                                                                    {design.sizeDetail}
                                                                </td>
                                                                <td>  {currencyFormat(design.price)}  </td>
                                                            </tr>

                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </div>
                                </Form.Group>
                            </Col>
                        </td>

                        <td>
                            {!props.product_?.productId ? '-' :
                                <Form.Control
                                    readOnly={props.product_?.productId ? false : true}
                                    style={{ "height": "37px" }}
                                    onChange={(event) => {
                                        if (event.target.value > 0) {
                                            let temp = { ...product }
                                            temp.quantity = event.target.value
                                            setProduct(temp)
                                        } else {
                                            setProduct({ ...product, quantity: 1 })
                                        }

                                    }}
                                    value={props.product_?.quantity}
                                    type="Number"
                                    min={1}
                                ></Form.Control>
                            }
                        </td>

                        <td>  {currencyFormat(props.product_?.price)}  </td>

                        <td>
                            {bodyParts.map((item, index) => {
                                if (item.value === props.product_?.bodyPart) {
                                    return item.label
                                }
                            })
                            }
                        </td>

                        <td>
                            {color.map((item, index) => {
                                if (item.value === props.product_?.color) {
                                    return item.label
                                }
                            })
                            }
                        </td>
                        <td> {currencyFormat(props.product_.subTotal)} </td>

                    </tr>
                </>

            }
        </>
    )
}

export default React.memo(ProductRow);